import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalService } from '../../../global/services/global.service';

const SAVE_JOB_URL = '/saveJsonObject?action_code=csibch';
const EXECUTE_JOB_URL = '/executeJob';

export interface ExecuteJobParams {
  job_id: string | number;
  job_params: string;
  tax_year: string | number;
  scenario: string | number;
  jcd_key: string | number;
}

/**
 * Job Console feature service.
 *
 * Replicates the minimum payload that the original `JsonObjectFactory.saveJSON`
 * built for `/saveJsonObject?action_code=csibch`, but without the
 * `WorkspaceService.activeScreen.filters` dependency that the admin shell does
 * not provide. Mirrors the shape used by `AdminActionsService.saveAction`.
 */
@Injectable({
  providedIn: 'root',
})
export class AdminJobConsoleService {
  constructor(
    private http: HttpClient,
    private globalService: GlobalService,
  ) {}

  updateJob(baseUrl: string, jobConsoleParams: any): Observable<any> {
    const gp = this.globalService.global?.globalParams || {};
    const fd = new FormData();
    fd.append('json_data', JSON.stringify(jobConsoleParams ?? {}));
    fd.append('tax_year', String(gp.tax_year ?? ''));
    fd.append('scenario', String(gp.scenario ?? ''));
    fd.append('jcd_key', String(gp.jcd_key ?? ''));
    fd.append('issue_id', String(gp.issue_id ?? ''));
    fd.append('issue_short_desc', String(gp.issue_short_desc ?? ''));
    fd.append('checkLockedbj', JSON.stringify([{}]));

    return this.http.post<any>(`${baseUrl}${SAVE_JOB_URL}`, fd, {
      withCredentials: true,
    });
  }

  executeJob(adminApiUrl: string, params: ExecuteJobParams): Observable<any> {
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([k, v]) => {
      httpParams = httpParams.set(k, String(v ?? ''));
    });
    return this.http.get<any>(`${adminApiUrl}${EXECUTE_JOB_URL}`, {
      params: httpParams,
      withCredentials: true,
    });
  }
}
